import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PaginationState } from "../../models/pagination";

type ListState = {
  pagination: PaginationState;
  searchText: string;
};

type AudiencesState = {
  ui: {
    regular: ListState,
  };
};

export const initialState: AudiencesState = {
  ui: {
    regular: {
      pagination: {
        pageNo: 0,
        pageSize: 0
      },
      searchText: ""
    },
  }
};

const audiencesSlice = createSlice({
  name: "audiences",
  initialState,
  reducers: {
    reset: () => initialState,
    setRegularPagination: (state, action: PayloadAction<PaginationState>) => ({
      ...state,
      ui: {
        ...state.ui,
        regular: {
          ...state.ui.regular,
          pagination: action.payload
        }
      }
    }),
    setRegularSearchText: (state, action: PayloadAction<string>) => ({
      ...state,
      ui: {
        ...state.ui,
        regular: {
          ...state.ui.regular,
          searchText: action.payload
        }
      }
    }),
  }
});

export const {
  reset,
  setRegularPagination,
  setRegularSearchText,
} = audiencesSlice.actions;

export default audiencesSlice.reducer;
